import { SituationValues } from 'helpers/enums/Assembleia';

interface FiltrosState {
  situation: {
    label: string;
    value: SituationValues;
  }[];
  filter: {
    idEvento: number | undefined;
    tiposEventos: Number[] | string | undefined;
    modalidades: Number[] | string | undefined;
    flgEventoTeste: boolean | null;
    status: Number[] | string | undefined;
    cooperativas: String[] | string | undefined;
    startDate: string;
    endDate: string;
  };
}

type FiltrosActionTypes = 'setFilter' | 'setSituation';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value?: any;
}

function formatDate(date: any) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

const today = new Date();

export const initialStartDate = formatDate(
  new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30, 0, 0, 0)
);
export const initialEndDate = formatDate(
  new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 30,
    23,
    59,
    59
  )
);

export const filtrosInitialState: FiltrosState = {
  situation: [],
  filter: {
    idEvento: undefined,
    tiposEventos: undefined,
    modalidades: undefined,
    status: undefined,
    flgEventoTeste: null,
    cooperativas: undefined,
    startDate: initialStartDate,
    endDate: initialEndDate,
  },
};

export const filtrosReducer = (
  state: FiltrosState,
  action: FiltrosAction
): FiltrosState => {
  switch (action.type) {
    case 'setFilter':
      return {
        ...state,
        filter: { ...state.filter, ...action.value },
      };
    case 'setSituation':
      return {
        ...state,
        situation: action.value,
      };
    default:
      return state;
  }
};
